module.exports = __webpack_public_path__ + "img/pic-640-3.b4b7059b.webp";